import React from 'react';
import { LeafIcon, RecycleIcon, SproutIcon, Trash2Icon } from 'lucide-react';
import { collections, materials, type MaterialId } from '../../data/collectes';
const icons: Record<MaterialId, typeof RecycleIcon> = {
  recyclage: RecycleIcon,
  ordures: Trash2Icon,
  organiques: LeafIcon,
  verts: SproutIcon
};
const MAX_VISIBLE = 3;
export function CollectionList() {
  const [next, ...upcoming] = collections;
  const NextIcons = next.materials.slice(0, MAX_VISIBLE);
  return <section aria-labelledby="collections-title" data-id="element-629" data-mp="tx1ktqddxqey">
      <h2 id="collections-title" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-630" data-mp="twjchvdg7lqo">
        Your next collections
      </h2>

      <div className="mt-5 grid gap-5 sm:grid-cols-2" data-id="element-631" data-mp="jyvfeysde25c">
        {/* Next collection — primary */}
        <article className="flex flex-col rounded-3xl bg-ville-navy p-7 text-white shadow-xl shadow-ville-navy/20 sm:col-span-2" data-id="element-632" data-mp="2zpzv7fpk5ab6">
          <span className="inline-flex w-fit items-center gap-2 rounded-full bg-ville-lime px-3 py-1 text-xs font-bold uppercase tracking-wider text-ville-navy" data-id="element-633" data-mp="34pcpglirdjns">
            Collection under way
          </span>
          <p className="mt-4 text-3xl font-extrabold leading-tight tracking-tight" data-id="element-634" data-mp="2oizrqnbwwgof">{next.weekday}</p>
          <p className="mt-1 text-sm text-white/70" data-id="element-635" data-mp="32iiq4oex8dnj">
            {next.date} · the truck is on its way to your address
          </p>

          <ul className="mt-6 space-y-2.5" data-id="element-636" data-mp="2xkqzrytxczlg">
            {NextIcons.map(id => {
            const Icon = icons[id];
            return <li key={id} className="flex items-center gap-3 rounded-2xl bg-white/10 px-4 py-3" data-id="element-637" data-mp="37hlwqdajurxm">
                  <Icon className="h-5 w-5 shrink-0 text-ville-lime" aria-hidden="true" data-id="element-638" data-mp="3l8gyl5mms8rp" />
                  <span className="font-bold" data-id="element-639" data-mp="3h63u0kjmegwi">{materials[id].label}</span>
                  <span className="ml-auto text-sm text-white/60" data-id="element-640" data-mp="3v6ejbj5a7nfk">{materials[id].hint}</span>
                </li>;
          })}
          </ul>
        </article>

        {/* Following collections */}
        {upcoming.map(collection => {
        const visible = collection.materials.slice(0, MAX_VISIBLE);
        const extra = collection.materials.length - visible.length;
        return <article key={collection.id} className="flex flex-col rounded-3xl border border-slate-200 bg-white p-7" data-id="element-641" data-mp="2wuu3uu8bi2yj">
              <span className="text-xs font-bold uppercase tracking-wider text-ville-blue" data-id="element-642" data-mp="31lk9m8kno7tr">Next collection</span>
              <p className="mt-2 text-xl font-extrabold leading-tight text-ville-navy" data-id="element-643" data-mp="36jc3h84v240l">
                {collection.weekday} {collection.date}
              </p>

              <ul className="mt-6 flex items-start justify-between gap-2" data-id="element-644" data-mp="3flbixw08901f">
                {visible.map(id => {
              const Icon = icons[id];
              return <li key={id} className="flex min-w-0 flex-1 flex-col items-center text-center" data-id="element-645" data-mp="3khsfnelhsmq4">
                      <span className="grid h-11 w-11 place-items-center rounded-full bg-ville-mist text-ville-deep" aria-hidden="true" data-id="element-646" data-mp="1q65e7983ho0r">
                        <Icon className="h-5 w-5" data-id="element-647" data-mp="1dw5zu3v2rohj" />
                      </span>
                      <span className="mt-2 text-[11px] font-bold leading-tight text-ville-navy" data-id="element-648" data-mp="1du2zapwaqcyk">
                        {materials[id].label}
                      </span>
                    </li>;
            })}
                {extra > 0 && <li className="flex min-w-0 flex-1 flex-col items-center text-center" data-id="element-649" data-mp="21k5marlcssqb">
                    <span className="grid h-11 w-11 place-items-center rounded-full border border-dashed border-slate-300 text-sm font-bold text-ville-deep" data-id="element-650" data-mp="1wnp1o7dd4whz">
                      +{extra}
                    </span>
                    <span className="mt-2 text-[11px] font-bold leading-tight text-slate-500" data-id="element-651" data-mp="1nl5yfm5o0hv7">
                      {extra > 1 ? 'collections' : 'collection'}
                    </span>
                  </li>}
              </ul>
            </article>;
      })}
      </div>
    </section>;
}